import { Pagination } from "@mui/material"
import { FC, useEffect, useMemo, useState } from "react"

import { ProductCard } from "src/components/common/productCard"

import { create } from "src/helpers/bem"

import { calculatePrice } from "src/helpers/price"
import { useBookings } from "src/states/bookings"
import { useCart } from "src/states/shop/carts"
import { useProducts } from "src/states/shop/products"

import { TranslationMessages } from "src/translations"

import styles from "./ShopOverviewProducts.module.scss"

const bem = create(styles, "ShopOverviewProducts")

export type ShopOverviewProductsProps = {
  messages: TranslationMessages
}

export const ShopOverviewProducts: FC<ShopOverviewProductsProps> = ({
  messages,
}) => {
  const m = messages.pages.shop.overview.products
  const { filteredProducts } = useProducts()
  const [page, setPage] = useState(1)
  const productsPerPage = 25
  const pageCount = Math.ceil(filteredProducts.length / productsPerPage)
  const pagedProducts = useMemo(() => {
    return filteredProducts.slice(
      (page - 1) * productsPerPage,
      (page - 1) * productsPerPage + productsPerPage,
    )
  }, [filteredProducts, page])

  const cart = useCart()
  const { bookings } = useBookings()
  const currentBooking = bookings?.find((b) => b.id === cart.id)
  const bookingAssignedSize = currentBooking?.assignedStandSize
  const exhibitionDuration = currentBooking ? currentBooking.duration : 0

  useEffect(() => {
    if (pageCount < page) {
      setPage(1)
    }
  }, [pageCount, page])

  return (
    <div className={bem()}>
      {pageCount > 1 && (
        <div className={bem("pagination")}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={(_, value) => setPage(value)}
          />
        </div>
      )}
      <div className={bem("products")}>
        {pagedProducts &&
          pagedProducts.map((product, i) => (
            <ProductCard
              key={i}
              className={bem("products__product")}
              pricePrefix={product?.hasVariants ? m.prefix : ""}
              {...product}
              price={calculatePrice({
                calculationMethod: product.productCalculation!,
                price: product.price ?? 0,
                duration: exhibitionDuration,
                assignedStandSize: bookingAssignedSize,
              })}
            />
          ))}
      </div>
    </div>
  )
}
